import { ETheme } from "@/DependenciesV9";
import { NavSubItem, NavSubItemProps } from "@fluentui/react-nav-preview";

interface NavSubItemCustomProps {
  rcName?: string;
  theme?: ETheme;
}

const NavSubItemCustom = (props: NavSubItemProps & NavSubItemCustomProps) => {
  return <NavSubItem {...props}/>
};

export default NavSubItemCustom;